import { Button, ButtonProps, makeStyles } from "@material-ui/core";
import { AddCircle, ArrowDropDown, ArrowForwardIos, Launch, Visibility } from "@material-ui/icons";
import Add from "./svgs/add";

export interface ILyfeButtonProps extends ButtonProps {
	use?:
		| "read-more"
		| "new-page"
		| "add"
		| "fab"
		| "link-with-fab"
		| "primary-action"
		| "secondary-action"
		| "primary"
		| "secondary"
		| "fab-link"
		| "open-same-page"
		| "black"
		| "black-outlined";
}

export default function LyfeButton(props: ILyfeButtonProps) {
	const classes = useStyles({ props });

	function renderClass() {
		if (props.variant === "contained" && !props.use) return classes.containedButton;
		if (props.variant === "outlined" && !props.use) return classes.outlinedButton;
		if (props.use === "black") return classes.blackButton;
		if (props.use === "black-outlined") return classes.blackOutlined;
		if (props.use === "read-more") return classes.readMore;
		if (props.use === "open-same-page") return classes.readMore;
		if (props.use === "fab-link") return classes.fabLink;
		if (!props.variant && props.use === "new-page") return classes.noTextTransform;
		if (!props.variant && props.use === "add") return classes.add;
		if (props.use?.match(/action/)) return classes.action;
		return props.className;
	}

	switch (props.use) {
		case "primary":
			return <Button {...props} className={renderClass()} variant="contained" />;
		case "secondary":
			return <Button {...props} className={renderClass()} variant="outlined" />;
		case "black":
			return <Button {...props} className={renderClass()} variant="contained" />;
		case "black-outlined":
			return <Button {...props} className={renderClass()} variant="outlined" />;
		case "read-more":
			return <Button {...props} className={renderClass()} endIcon={<ArrowForwardIos />} disableRipple disableElevation />;
		case "open-same-page":
			return (
				<Button {...props} className={renderClass()} disableRipple disableElevation>
					{" "}
					<Visibility />
				</Button>
			);
		case "new-page":
			return <Button {...props} className={renderClass()} endIcon={<Launch />} />;
		case "add":
			return <Button {...props} className={renderClass()} startIcon={<AddCircle fontSize="large" />} />;
		case "fab-link":
			return <Button {...props} className={renderClass()} startIcon={<Add fontSize="large" />} />;
		case "primary-action":
			return <Button {...props} className={renderClass()} variant="contained" endIcon={<ArrowDropDown />} />;
		case "secondary-action":
			return <Button {...props} className={renderClass()} variant="outlined" endIcon={<ArrowDropDown />} />;
		default:
			return <Button {...props} className={renderClass()} />;
	}
}

const useStyles = makeStyles({
	containedButton: {
		textTransform: "none",
		color: "white",
	},
	blackButton: {
		fontSize: "15px",
		whiteSpace: "nowrap",
		letterSpacing: "0.15px",
		textTransform: "none",
		color: "white",
		borderRadius: "8px",
		backgroundColor: "#003538",
		fontWeight: "bold",
		padding: "12px 20px 10px",
		"&:hover": {
			boxShadow: "none",
			backgroundColor: "#003538",
		},
		"&.MuiButton-contained:disabled": {
			backgroundColor: "#00353866",
		},
	},
	blackOutlined: {
		fontSize: "15px",
		whiteSpace: "nowrap",
		letterSpacing: "0.15px",
		textTransform: "none",
		borderRadius: "8px",
		color: "#003538",
		fontWeight: "bold",
		"&:hover": {
			boxShadow: "0 0.063rem 0.25rem 0 rgb(15 17 20 / 22%)",
		},
	},
	outlinedButton: {
		textTransform: "none",
	},
	readMore: {
		fontWeight: 600,
		textTransform: "none",
		"&:hover": {
			boxShadow: "none",
			backgroundColor: "transparent",
		},
	},
	noTextTransform: {
		textTransform: "none",
		fontWeight: "normal",
		"&:hover": {
			boxShadow: "none",
		},
	},
	add: {
		textTransform: "none",
		fontWeight: "normal",
		fontSize: "1.125rem",
		"&:hover": {
			boxShadow: "none",
		},
	},
	action: {
		fontWeight: 600,
	},
	fabLink: {
		textTransform: "none",
		fontWeight: "normal",
		margin: "1.438rem 0.125rem 2rem",
		padding: "1.25rem 9.563rem 1.25rem 9.625rem",
		boxShadow: "0 0 0.5rem 0 rgba(0, 0, 0, 0.08)",
		backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23367BF5FF' stroke-width='2' stroke-dasharray='3%2c7' stroke-dashoffset='0' strokeLinecap='square'/%3e%3c/svg%3e")`,
	},
});
